import { getConnectionManager, HubConnectionManager } from 'common/streaming/hubConnectionManager';
import IDispatcher from "common/dispatcher";
import deliveryPeriodService from 'features/deliveryPeriods/deliveryPeriod.service';
import { DeliveryPeriodUpdated } from '../deliveryPeriods/deliveryPeriod.actions';
import MemoizeDebounce from 'common/decorators/memoizedDebounce';

interface IBidChangeEventStreamingService {
    start(dispatcher: IDispatcher): Promise<any>;
}

class BidChangeEventStreamingService implements IBidChangeEventStreamingService {
    private hubConnectionManager: HubConnectionManager;
    private dispatcher: IDispatcher;
    private isStarted: boolean;

    constructor() {
        this.hubConnectionManager = getConnectionManager();
    }

    public async start(dispatcher: IDispatcher): Promise<any> {
        if (this.isStarted) return;

        this.isStarted = true;

        this.dispatcher = dispatcher;
        const conn = await this.hubConnectionManager.getConnectionAsync();
        conn.on("BidUpdated", ev => this.onBidUpdated(ev.deliveryPeriodId, dispatcher));
    }

    @MemoizeDebounce(1000, true, false)
    private async onBidUpdated(deliveryPeriodId: string, dispatcher: IDispatcher) {
        const deliveryPeriod = await deliveryPeriodService.getDeliveryPeriod(deliveryPeriodId);
        dispatcher.dispatch(new DeliveryPeriodUpdated(deliveryPeriod).toObject());
    }
}

const bidChangeEventStreamingService: IBidChangeEventStreamingService = new BidChangeEventStreamingService();
export default bidChangeEventStreamingService;